export const extractPathFromUrl = (url) => {
    const urlObject = new URL(url);
    // Remove the first slash
    return urlObject.pathname.substring(1);
};
